// @ts-nocheck

import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // Auth status
    status: "",

    // Auth token
    token: localStorage.getItem("token") || "",

    // Current user id
    userID: ""
  },

  mutations: {
    authRequest(state) {
      state.status = "loading";
    },

    authSuccess(state: Record<string, string>, token: string, userID: string) {
      state.status = "success";
      state.token = token;
      state.userID = userID;
    },

    authError(state) {
      state.status = "error";
    },

    logout(state) {
      state.status = "";
      state.token = "";
      state.userID = "";
    }
  },

  actions: {
    // Log in a user
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("authRequest");

        axios
          .post("https://api.kvillenation.com/users/authenticate", user)
          .then(resp => {
            const token = resp.data.string;
            const userID = resp.data.userID;

            localStorage.setItem("token", token);
            axios.defaults.headers.common["Authorization"] = token;

            commit("authSuccess", token, userID);
            resolve(resp);
          })
          .catch(err => {
            commit("authError");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    // Log out a user
    logout({ commit }) {
      return new Promise(resolve => {
        commit("logout");

        localStorage.removeItem("token");
        delete axios.defaults.headers.common["Authorization"];

        resolve();
      });
    }
  },

  getters: {
    isLoggedIn: state => {
      return !!state.token;
    },

    authStatus: state => {
      return state.status;
    }
  }
});
